import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'authenticator.onboarding.setup.title',
    defaultMessage: 'Preparing your space',
  },
  subtitle: {
    id: 'authenticator.onboarding.setup.subtitle',
    defaultMessage: 'Please wait, your Revers.io experience starts very soon.',
  },
  readyTitle: {
    id: 'authenticator.onboarding.setup.readyTitle',
    defaultMessage: 'Your space is ready',
  },
  readySubtitle: {
    id: 'authenticator.onboarding.setup.readySubtitle',
    defaultMessage: 'Redirecting…',
  },
  progressCompleted: {
    id: 'authenticator.onboarding.setup.progressCompleted',
    defaultMessage: 'Completed',
  },
  progressPercent: {
    id: 'authenticator.onboarding.setup.progressPercent',
    defaultMessage: '{percent, number, percent}',
  },
  stepCounter: {
    id: 'authenticator.onboarding.setup.stepCounter',
    defaultMessage: 'Step {current} of {total}',
  },
  stepSellerContext: {
    id: 'authenticator.onboarding.setup.stepSellerContext',
    defaultMessage: 'Creating your account',
  },
  stepTemplateDuplication: {
    id: 'authenticator.onboarding.setup.stepTemplateDuplication',
    defaultMessage: 'Setting up your return rules',
  },
  stepDemoOrders: {
    id: 'authenticator.onboarding.setup.stepDemoOrders',
    defaultMessage: 'Generating demo orders',
  },
  stepDemoFiles: {
    id: 'authenticator.onboarding.setup.stepDemoFiles',
    defaultMessage: 'Generating demo files',
  },
  stepDone: {
    id: 'authenticator.onboarding.setup.stepDone',
    defaultMessage: 'Completed',
  },
  stepRunning: {
    id: 'authenticator.onboarding.setup.stepRunning',
    defaultMessage: 'In progress',
  },
  stepPending: {
    id: 'authenticator.onboarding.setup.stepPending',
    defaultMessage: 'Pending',
  },
  stepFailed: {
    id: 'authenticator.onboarding.setup.stepFailed',
    defaultMessage: 'Failed',
  },
  failedTitle: {
    id: 'authenticator.onboarding.setup.failedTitle',
    defaultMessage: 'The setup of your account was interrupted',
  },
  failedDescription: {
    id: 'authenticator.onboarding.setup.failedDescription',
    defaultMessage:
      'What is already done is kept: retrying resumes from the failed step.',
  },
  retry: {
    id: 'authenticator.onboarding.setup.retry',
    defaultMessage: 'Retry',
  },
  salesLeadConfirmEmailCommandError: {
    id: 'authenticator.onboarding.setup.salesLeadConfirmEmailCommandError',
    defaultMessage: 'An error occured while confirming the email',
  },
});
